"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _createCoreMiddleware = require("../Middleware/Avatar/createCoreMiddleware");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Avatar = function Avatar(_ref) {
  var ariaHidden = _ref['aria-hidden'],
      className = _ref.className,
      fromUser = _ref.fromUser;
  console.warn('botframework-webchat: <Avatar> component is deprecated and will be removed on or after 2022-02-25. Please use `useRenderAvatar` hook instead.');
  return _react.default.createElement(_createCoreMiddleware.DefaultAvatar, {
    "aria-hidden": ariaHidden,
    className: className,
    fromUser: fromUser
  });
};

Avatar.defaultProps = {
  'aria-hidden': false,
  className: '',
  fromUser: false
};
Avatar.propTypes = {
  'aria-hidden': _propTypes.default.bool,
  className: _propTypes.default.string,
  fromUser: _propTypes.default.bool
};
var _default = Avatar;
exports.default = _default;